import * as React from 'react';

import { UnsubscribePage } from '../components/mail/UnsubscribePage';
import Footer from '../components/shared/Footer';
import Layout from '../components/shared/Layout';

const Mail: React.FC = () => (
  <Layout>
    <UnsubscribePage />
    <Footer />
  </Layout>
);

export default Mail;
